import { View } from "./View";

export const ReservedWallets = () => {
  return <View />;
};
